import { Stack, Typography } from "@mui/material";
import WaydImpactBar from "../WaydImpactBar";
import WaydFrequencyChart from "../WaydFrequencyChart";
import WaydValueMetricBox from "../WaydValueMetricBox";
import { WaydSectionProps } from "./types";

const WAYD_SECTION_CONTENT_HEIGHT = 475;

export default function WaydSection({
  offenseImpactData,
  defenseImpactData,
  offenseFrequencyData,
  defenseFrequencyData,
  valueMetrics,
}: WaydSectionProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      sx={{ width: "100%" }}
    >
      <Stack spacing={1} sx={{ flex: 1 }}>
        <Typography variant="h4" textAlign="center">
          Impact
        </Typography>

        <Typography variant="h6" textAlign="center" color="text.secondary">
          BWAYD 1.0
        </Typography>

        <Stack
          spacing={4}
          height={WAYD_SECTION_CONTENT_HEIGHT}
          justifyContent="space-evenly"
        >
          <Stack spacing={2} alignItems="center">
            <Typography variant="body2" textAlign="center">
              OFFENSE
            </Typography>
            {offenseImpactData.map((impact) => (
              <WaydImpactBar
                key={impact.title}
                title={impact.title}
                value={impact.value}
                percentile={impact.percentile}
              />
            ))}
          </Stack>

          <Stack spacing={2} alignItems="center">
            <Typography variant="body2" textAlign="center">
              DEFENSE
            </Typography>
            {defenseImpactData.map((impact) => (
              <WaydImpactBar
                key={impact.title}
                title={impact.title}
                value={impact.value}
                percentile={impact.percentile}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>

      <Stack spacing={1} sx={{ flex: 1 }}>
        <Typography variant="h4" textAlign="center" whiteSpace="nowrap">
          Role Breakdown
        </Typography>

        <Typography variant="h6" textAlign="center" color="text.secondary">
          {/*WAYD*/} Frequency
        </Typography>

        <Stack
          spacing={4}
          height={WAYD_SECTION_CONTENT_HEIGHT}
          justifyContent="space-evenly"
        >
          <Stack spacing={1}>
            <Typography variant="body2" textAlign="center">
              OFFENSE
            </Typography>
            <WaydFrequencyChart data={offenseFrequencyData} />
          </Stack>

          <Stack spacing={1}>
            <Typography variant="body2" textAlign="center">
              DEFENSE
            </Typography>
            <WaydFrequencyChart data={defenseFrequencyData} />
          </Stack>
        </Stack>
      </Stack>

      <Stack spacing={1} sx={{ flex: 1 }}>
        <Typography variant="h4" textAlign="center">
          Value
        </Typography>

        <Typography variant="h6" textAlign="center" color="text.secondary">
          On-Court Value
        </Typography>

        <Stack
          spacing={2}
          height={WAYD_SECTION_CONTENT_HEIGHT}
          justifyContent="space-evenly"
          alignItems="center"
        >
          {valueMetrics.map((metric) => (
            <WaydValueMetricBox
              value={metric.value}
              label={metric.label}
              color={metric.color}
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
